import React from "react";

export default function BotsPage() {
  return (
    <div className="min-h-screen font-roboto text-white bg-gradient-to-br from-slate-900 via-gray-800 to-indigo-900">
      <div className="text-center py-20">
        <h1 className="text-5xl font-bold mb-6">I Nostri Bot</h1>
        <p className="text-lg text-indigo-300">
          Scopri i nostri bot di trading progettati per ogni tipo di investitore.
        </p>
        {/* Qui puoi aggiungere cards, sezioni, immagini dei tuoi Bott */}
      </div>
    </div>
  );
}
